import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { withLocalize } from "react-localize-redux";
import styled from "styled-components";
import "../../../styles/app.scss";
import "../../../styles/header.scss";
import translations from "../../../translations/header.json";
import { selectUser } from "../../../store/features/user";
import { useAppSelector } from "../../../store/hooks";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";

import HeaderWeb from "./HeaderWeb";
import HeaderMobile from "./HeaderMobile";

const StyledHeader = styled.div`
	${(props) => `
    .customizable-text {
      color: ${props.textColor} !important;
    }
	.customizable-icon {
		fill: ${props.primaryColor} !important;
		stroke: ${props.primaryColor} !important;
	}
  `};
`;

const Header = (props) => {
	const [isMenuOpen, setMenuOpen] = useState(false);
	const [isCustomization, setIsCustomization] = useState(false);
	const [redir, setRedir] = useState(null);
	const [backButton, setBackButton] = useState({
		backButtonEnabled: false,
	});
	const [accountModalOpen, setAccountModalOpen] = useState(false);
	const handleModalClose = () => setAccountModalOpen(false);
	const userMeta = useAppSelector(selectUser);
	const history = useHistory();
	const location = useLocation();
	useEffect(() => {
		// Add translation when component mounts
		props.addTranslation(translations);

		const search = location.search;
		const isCustomization =
			new URLSearchParams(search).get("customization") === "true";
		setIsCustomization(isCustomization);
	}, []);

	const backButtonPages = [
		{
			route: "signup",
		},
		{
			route: "login",
		},
		{
			route: "verify-code",
		},
	];

	const openNav = () => {
		document.getElementById("myNavbar").style.position = "fixed";
		document.getElementById("myNav").style.width = "100%";
	};

	const closeNav = () => {
		document.getElementById("myNavbar").style.position = "fixed";
		document.getElementById("myNavbar").style.fixed = "top";
		document.getElementById("myNav").style.width = "0%";
	};

	const changeNav = () => {
		!isMenuOpen ? openNav() : closeNav();
		setMenuOpen(!isMenuOpen);
	};

	const handleContact = async () => {
		if (props.config.contactEmail) {
			window.open(`mailto:${props.config.contactEmail}`);
		}
	};

	useEffect(() => {
		const matchingPage = backButtonPages.find((page) =>
			location.pathname.includes(page.route)
		);

		if (matchingPage) {
			setBackButton({
				backButtonEnabled: true,
				redirectUrl: matchingPage.redirectUrl,
				buttonTextKey: matchingPage.buttonTextKey,
				onClickAction: matchingPage.redirectUrl
					? undefined
					: () => {
							history.goBack();
					  },
			});
		} else {
			setBackButton({
				backButtonEnabled: false,
			});
		}

		if (location.state && location.state.fromProfile) {
			setBackButton({
				backButtonEnabled: true,
				buttonTextKey: "back",
				onClickAction() {
					history.goBack();
				},
			});
		}
	}, [props.isPreview, props.isMobile, location.pathname, userMeta]);

	if (redir != null) {
		return (
			<Redirect
				to={
					props.activeLanguage
						? `/${props.activeLanguage.code}/${redir}`
						: `/${redir}`
				}
			/>
		);
	}

	return (
		<StyledHeader
			textColor={props.config.headerTextColor}
			primaryColor={props.config.primaryColor}
			className={isCustomization ? "no-pointer-event" : ""}
		>
			{!props.isMobile ? (
				<HeaderWeb
					backButton={backButton}
					accountModalOpen={accountModalOpen}
					setAccountModalOpen={setAccountModalOpen}
					userMeta={userMeta}
					handleModalClose={handleModalClose}
					handleContact={handleContact}
					config={props.config}
					{...props}
				/>
			) : (
				<HeaderMobile
					backButton={backButton}
					changeNav={changeNav}
					accountModalOpen={accountModalOpen}
					setAccountModalOpen={setAccountModalOpen}
					userMeta={userMeta}
					isMenuOpen={isMenuOpen}
					closeNav={closeNav}
					openNav={openNav}
					setMenuOpen={setMenuOpen}
					handleModalClose={handleModalClose}
					handleContact={handleContact}
					config={props.config}
					{...props}
				/>
			)}
		</StyledHeader>
	);
};

export default withLocalize(Header);
